export const HABITAT_MODULES = {
  profile: {
    id: 'profile',
    icon: '🧾',
    titleKey: 'habitat.modules.profile.title',
    descriptionKey: 'habitat.modules.profile.description',
  },
  services: {
    id: 'services',
    icon: '💼',
    titleKey: 'habitat.modules.services.title',
    descriptionKey: 'habitat.modules.services.description',
  },
  growth: {
    id: 'growth',
    icon: '📈',
    titleKey: 'habitat.modules.growth.title',
    descriptionKey: 'habitat.modules.growth.description',
  },
  presence: {
    id: 'presence',
    icon: '🌐',
    titleKey: 'habitat.modules.presence.title',
    descriptionKey: 'habitat.modules.presence.description',
  },
  management: {
    id: 'management',
    icon: '🏢',
    titleKey: 'habitat.modules.management.title',
    descriptionKey: 'habitat.modules.management.description',
  },
  networking: {
    id: 'networking',
    icon: '🛜',
    titleKey: 'habitat.modules.networking.title',
    descriptionKey: 'habitat.modules.networking.description'
  }
};

export const HABITAT_TASKS = {
  // Profile Module Tasks
  'basic-information': {
    id: 'basic-information',
    titleKey: 'habitat.tasks.basicInformation.title',
    descriptionKey: 'habitat.tasks.basicInformation.description',
    component: 'HabitatProfile',
  },
  'professional-validation': {
    id: 'professional-validation',
    titleKey: 'habitat.tasks.professionalValidation.title',
    descriptionKey: 'habitat.tasks.professionalValidation.description',
    component: 'ProfessionalValidation',
  },
  'company': {
    id: 'company',
    titleKey: 'habitat.tasks.company.title',
    descriptionKey: 'habitat.tasks.company.description',
    component: 'CompanyRegistration',
  },
  'create-subscription': {
    id: 'create-subscription',
    titleKey: 'habitat.tasks.createSubscription.title',
    descriptionKey: 'habitat.tasks.createSubscription.description',
    component: 'DoctorSubscriptionDetails',
  },
  'create-addresses': {
    id: 'create-addresses',
    titleKey: 'habitat.tasks.createAddress.title',
    descriptionKey: 'habitat.tasks.createAddress.description',
    component: 'HabitatAddress',
  },

  // Services Module Tasks
  'configure-services': {
    id: 'configure-services',
    titleKey: 'habitat.tasks.configureServices.title',
    descriptionKey: 'habitat.tasks.configureServices.description',
    component: 'ServiceConfiguration',
  },
  'target-audience': {
    id: 'target-audience',
    titleKey: 'habitat.tasks.targetAudience.title',
    descriptionKey: 'habitat.tasks.targetAudience.description',
    component: 'TargetAudienceConfiguration',
  },
  'configure-products': {
    id: 'configure-products',
    titleKey: 'habitat.tasks.configureProducts.title',
    descriptionKey: 'habitat.tasks.configureProducts.description',
    component: 'ProductConfiguration',
  },

  // Networking Module Tasks
  'my-tree': {
    id: 'my-tree',
    titleKey: 'habitat.tasks.myTree.title',
    descriptionKey: 'habitat.tasks.myTree.description',
    component: 'NetworkingMyTree',
  },
  'partners': {
    id: 'partners',
    titleKey: 'habitat.tasks.partners.title',
    descriptionKey: 'habitat.tasks.partners.description',
    component: 'NetworkingPartners',
  },
  'ecosystem': {
    id: 'ecosystem',
    titleKey: 'habitat.tasks.ecosystem.title',
    descriptionKey: 'habitat.tasks.ecosystem.description',
    component: 'NetworkingEcosystem',
  },
  'indications': {
    id: 'indications',
    titleKey: 'habitat.tasks.indications.title',
    descriptionKey: 'habitat.tasks.indications.description',
    component: 'NetworkingIndications',
  },

  // Growth Module Tasks
  'specializations': {
    id: 'specializations',
    titleKey: 'habitat.tasks.specializations.title',
    descriptionKey: 'habitat.tasks.specializations.description',
    component: 'Specializations',
  },
  'certifications': {
    id: 'certifications',
    titleKey: 'habitat.tasks.certifications.title',
    descriptionKey: 'habitat.tasks.certifications.description',
    component: 'Certifications',
  },
  'professional-experience': {
    id: 'professional-experience',
    titleKey: 'habitat.tasks.professionalExperience.title',
    descriptionKey: 'habitat.tasks.professionalExperience.description',
    component: 'ProfessionalExperience',
  },

  // Presence Module Tasks
  'digital-profile': {
    id: 'digital-profile',
    titleKey: 'habitat.tasks.digitalProfile.title',
    descriptionKey: 'habitat.tasks.digitalProfile.description',
    component: 'DigitalProfile',
  },
  'social-networks': {
    id: 'social-networks',
    titleKey: 'habitat.tasks.socialNetworks.title',
    descriptionKey: 'habitat.tasks.socialNetworks.description',
    component: 'SocialNetworks',
  },

  // Growth Module Tasks
  'archetype': {
    id: 'archetype',
    titleKey: 'habitat.tasks.archetype.title',
    descriptionKey: 'habitat.tasks.archetype.description',
    component: 'MyArchetype',
  },
  'behavioral-profile': {
    id: 'archetype',
    titleKey: 'habitat.tasks.behavioralProfile.title',
    descriptionKey: 'habitat.tasks.behavioralProfile.description',
    component: 'BehavioralProfile',
  }
};

export const HABITAT_TASK_STATUS = {
  completed: 'completed',
  inProgress: 'in-progress',
  pending: 'pending',
  locked: 'locked',
}; 